export default __webpack_public_path__ + "static/media/motorFourWheeler.39ef4b9e.svg";